import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IImageRepository } from './Iimage.repository';
import { ApiResponse, Image } from './models';


@Injectable({ providedIn: 'root' })
export class ImageRepository implements IImageRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);


	getImageDetail(image: string, user: string | null): Observable<ApiResponse<Image>> {
		let params = new HttpParams().set('image', image);
		if (user) params = params.set('user', user);
		return this.httpClient.get<ApiResponse<Image>>(this.config.domainImageAPI + '/api/Images/Detail', { params });
	}

}
